import React  from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import { parseBrowser } from 'ctm-util-functions';
import styles from './cross_sell_widget.css';
import { SimpleFlexbox } from '../flexbox/flexbox';
import { Badge } from '../form';
import { Text } from '../text/text';

/**
 *
 * @param {Object} props - the component's props
 * @param {String} props.identifier - the form element's identifier that indicates where it sits in state
 * @param {String} props.title - the widget title
 * @param {String} props.badgeLabel - the label text underneath the badge
 * @param {String} props.icon - the icon variant to use
 * @param {String} props.content - the SpeechBubble content
 * @param {String} props.value - the value of the check box from state
 * @param {Function} props.dispatch - dispatch function from redux
 * @returns {Node} A Cross cell widget component
 * @constructor
 */
const  _CrossSellWidget = (props) => {
    const { Agent } = parseBrowser(window.navigator.userAgent);
    if (Agent.isMobile) return null;

    const { identifier, icon, badgeLabel, value, title, dispatch, content } = props;
    const badgeSchema = {
        identifier,
        stateKey: 'vertical.quote',
        field: {
            type: 'badgegroup',
            UIComponent: 'badge_primary_small_rounded',
            metaType: 'checkbox',
            value: 'Y',
            default: 'N',
            label: badgeLabel,
            icon
        }
    };

    const checkboxSchema = {
        ...badgeSchema,
        field: {
            ...badgeSchema.field,
            UIComponent: 'checkbox_small_rounded'
        }
    };

    return (
        <div className={styles.root}>
            <div display="flex">
                <h2>{title}</h2>
                <hr />
            </div>
            <SimpleFlexbox display="flex">
                <div>
                    <Badge schema={badgeSchema} checkboxSchema={checkboxSchema} value={value} dispatch={dispatch} />
                </div>
                <div className={styles.text}>
                    <Text innerHTML={content} />
                </div>
            </SimpleFlexbox>
        </div>
    );
};

_CrossSellWidget.propTypes = {
    identifier: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    badgeLabel: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
    value: quoteFormSelector(state).getIn(props.identifier.split('.')) || 'N'
});

const CrossSellWidget = connect(mapStateToProps)(_CrossSellWidget);

export { _CrossSellWidget, CrossSellWidget };
